import React from 'react';
import AnnotationSubstepBody from './ToolTipComponents/AnnotationSubstepBody';
import CheckEveryHeader from './ToolTipComponents/CheckEveryHeader';

import DefaultButtonRow from './ToolTipComponents/DefaultButtonRow';
import { CheckEveryAnnotationToolTipProps } from '../types';

const AnnotationSubstepToolTip: React.FC<CheckEveryAnnotationToolTipProps> = props => {
  return (
    <div>
      <CheckEveryHeader
        workflowHook={props.workflowHook}
        labelerStateHook={props.labelerStateHook}
      />
      <AnnotationSubstepBody workflowHook={props.workflowHook} />
      <DefaultButtonRow workflowHook={props.workflowHook} />
    </div>
  );
};

export default React.memo(AnnotationSubstepToolTip);
